// extracted by mini-css-extract-plugin
export var fileUpload = "_fb-1";
export var modalButton = "_fb-0";